<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-account" icon-small title="لیست کاربران سایت" color="accent">
			<template v-slot:beforeBody>
				<div class="px-5 text-left">
					<v-btn color="primary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن کاربر
					</v-btn>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :headers="headers" :loading="loading" :items="users" :items-per-page="500" :search="search" class="elevation-1">
							<template v-slot:item.userName="{ item }">
								{{ `&lrm;${item.userName}` }}
							</template>
							<template v-slot:item.lastLoginDate_Persian="{ item }">
								{{ `${item.lastLoginDate_Persian.time} ${item.lastLoginDate_Persian.date}` }}
							</template>
							<template v-slot:item.isActive="{ item }">
								<v-icon v-if="item.isActive" color="success" title="غیرفعال">
									mdi-check-circle
								</v-icon>
								<v-icon v-else color="error" title="فعال">
									mdi-close-circle
								</v-icon>
							</template>
							<template v-slot:item.operations="{ item }">
								<td class="text-center">
									<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</td>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
			<v-dialog v-model="dialogUser" scrollable persistent max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات کاربر</span>
						<v-spacer />
						<v-btn @click="dialogUser = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-user ref="modifyUser" v-if="dialogUser" :data="selectedUser" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ModifyUser from './ModifyUser.vue'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-user': ModifyUser,
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
				localData: {},
				selectedUser: {},
				dialogUser: false,
				search: '',
				headers: [
					{
						text: 'نام کاربر',
						align: 'start',
						sortable: true,
						value: 'fullName',
					}, {
						text: 'نام کاربری',
						align: 'start',
						sortable: true,
						value: 'userName',
					}, {
						text: 'ایمیل',
						align: 'start',
						sortable: true,
						value: 'email',
					}, {
						text: 'دفعات مراجعه',
						align: 'center',
						sortable: true,
						value: 'viewCount',
					}, {
						text: 'آخرین فعالیت',
						align: 'center',
						sortable: true,
						value: 'lastLoginDate_Persian',
					}, {
						text: 'وضعیت اکانت',
						align: 'center',
						sortable: true,
						value: 'isActive',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						value: 'operations',
						width: 150,
					},
				],
				users: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/user/list', null)
					.then(
						response => {
							this.users = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			add() {
				this.selectedUser = { id: 0 }
				this.dialogUser = true
			},
			edit(item) {
				this.selectedUser = item
				this.dialogUser = true
			},
			callbck(result) {
				this.dialogUser = false
				if (result) { this.loadData() }
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/user/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style></style>
